import ClientFormController from './clientFormController';
import './clientForm.scss';

const ClientFormComponent = {
    template: require('./clientFormView.html'),
    controller: ClientFormController,
};

export default angular.module('app.clientform', [])
    .component('clientform', ClientFormComponent)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/clientForm/clientFormComponent.js